import strings from '../../dataSource/AggregatesMetadata.resx';

// order is important for display preference in column context menu
export const enum ColumnAggregateType {
  NONE,
  COUNT,
  AVG,
  MAX,
  MIN,
  SUM,
  STDEV,
  VAR
}

export const ColumnAggregateTypeName: string[] = [
  'NONE', 'COUNT', 'AVG', 'MAX', 'MIN', 'SUM', 'STDEV', 'VAR'
];

// needed for localization
export function getAggregateDisplayValue(aggregateValue: string): string {
  aggregateValue = aggregateValue ? aggregateValue.toUpperCase() : aggregateValue;
  if (aggregateValue && strings.hasOwnProperty(aggregateValue)) {
    const objectDescriptor = Object.getOwnPropertyDescriptor(strings, aggregateValue);
    if (objectDescriptor) {
      return objectDescriptor.value;
    }
  }
  return '';
}